
import React, {useEffect, useState} from 'react'
import GetFetch from '../helper/GetFetch';

export const FacturaElectronica = () => {

    const [stadoForm, setStadoForm] = useState(0);

    useEffect(() => {
        let datos = localStorage.getItem('dataUser');
        const dataAlumno = JSON.parse(datos);
        console.log(dataAlumno.carnet);
        const data = new FormData();
        data.append('carnet', dataAlumno.carnet);
        GetFetch.dteStadoFormulario(data).then(datos=>{
            
            if (datos.result.length > 0) {
                setStadoForm(datos.result[0].estado);                
            }
        })
    }, [])
    

    

  return (
    <>
    {
        stadoForm === 0 
            ?
            <div className='border border-primary m-4 p-4'>
            <p>Formulario de actualización de datos para factura electrónica</p>
        </div>
        : null
    }

    </>
  )
}


